<template>
    <div>
        <p class=" text-2xl text-center text-blue-400 font-bold font-poppins">Features of the App</p>

           <div class=" flex justify-around mt-20 rounded-lg md:flex-col">
               <div class="w-1/6 shadow-2xl p-4 md:m-auto md:w-4/5 rounded-lg">
                   <i class=" fa fa-gift border p-4 fa-2x bg-gray-200 text-blue-700 rounded-3xl"></i>
                   <p class=" mt-4 mb-4 font-semibold">Send a package</p>
                   <p>
                       Send packages quicker and safer by using the CarryGo App anywhere and anytime.
                    </p>
               </div>

               <div class="w-1/6 shadow-2xl p-4 md:m-auto md:w-4/5 md:mt-10 rounded-lg">
                   <i class=" fa fa-car border p-4 fa-2x bg-gray-200 text-blue-700 rounded-3xl"></i>
                   <p class=" mt-4 mb-4 font-semibold">Book a ride</p>
                   <p>Book yourself a cab or order vehicle pick up for your items in just few easy clicks.</p>
               </div>

               <div class="w-1/6 shadow-2xl p-4 md:m-auto md:w-4/5 md:mt-10 rounded-lg">
                   <i class=" fa fa-truck border p-4 fa-2x bg-gray-200 text-blue-700 rounded-3xl"></i>
                   <p class=" mt-4 mb-4 font-semibold">Haulage</p>
                   <p>Book Trucks and vans for heavy lifting through direct In app calls Nationwide.</p>
               </div>

               <div class="w-1/6 shadow-2xl p-4 md:m-auto md:w-4/5 md:mt-10 rounded-lg">
                   <i class=" fa fa-credit-card border p-4 fa-2x bg-gray-200 text-blue-700 rounded-3xl"></i>
                   <p class=" mt-4 mb-4 font-semibold">Buy for me</p>
                   <p>Get errand services for shopping or one time purchases  on the CarryGo App. Our CG carrier does it all for you.</p>
               </div>
           </div>
    </div>
</template>